module.exports = __webpack_public_path__ + "img/pm10.3cdf0fde.svg";